import FavouriteJobsProposalModal from './doubleOptIn/favourite';
import SingleConfirmationFavouriteJobsProposalModal from './singleOptIn/favourite';

export const loadFavouriteJobsSubscriptionModal = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  const {
    feature: {
      confirmationSingleClickEnabled
    },
  } = jrConfigGlobal;

  if (confirmationSingleClickEnabled) {
    new SingleConfirmationFavouriteJobsProposalModal(
      'favourite-jobs-subscription-modal',
      'jr-modal-favourite-jobs-wrapper',
      jrConfigGlobal,
    ).init();
  } else {
    new FavouriteJobsProposalModal(
      'favourite-jobs-subscription-modal',
      'jr-modal-favourite-jobs-wrapper',
      jrConfigGlobal,
    ).init();
  }
}